import { ActionContext, ActionTree, GetterTree } from "vuex";

const initialState: any = {
  sknPaymentMethod: -1,
  sknPaymentDeposit: -1,
  isConfirm: 0,
  loadData: false
};

const actions: ActionTree<any, any> = {
  setPayment({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setPayment", payload);
  },
  updatetPayment({ commit }: ActionContext<any, any>, payload: any): void {
    commit("updatetPayment", payload);
  },
  confirm({ commit }: ActionContext<any, any>, payload: number): void {
    commit("confirm", payload);
  },
  clearState({ commit }: ActionContext<any, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setPayment(state: any, payload: any) {
    Object.assign(state, { ...payload, loadData: true });
  },
  updatetPayment(state: any, payload: any) {
    Object.assign(state, { ...payload });
  },
  confirm(state: any, payload: number) {
    state.isConfirm = payload;
  },
  clearState(state: any) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<any, any> = {
  sknPaymentMethod(state: any) {
    return state.sknPaymentMethod;
  },
  sknPaymentDeposit(state: any) {
    return state.sknPaymentDeposit;
  },
  isConfirm(state: any) {
    return state.isConfirm;
  },
  loadData(state: any) {
    return state.loadData;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
